import React from "react";
import { VstInput, VstButton } from "vstui";
import { toastUtils } from "../../../../utils/toast-utils";
import { isValidNumber } from "libphonenumber-js";

export default class GetAppModal extends React.Component {
  constructor() {
    super();
    this.state = {
      sms: "",
      smsFailure: "",
      email: ""
    };
    this.onChange = this.onChange.bind(this);
    this.submitSMS = this.submitSMS.bind(this);
    // this.submitEmail = this.submitEmail.bind(this);
    this._formatSMS = this._formatSMS.bind(this);

    this._onFocus = this._onFocus.bind(this);
    this._smsFailure = this._smsFailure.bind(this);
  }

  onChange(field) {
    return e => this.setState({ [field]: e.currentTarget.value });
  }

  _onFocus(failure) {
    return e => this.setState({ [failure]: "" });
  }

  _isValidNumber() {
    const to = this._formatSMS();
    return isValidNumber(to, "US") || isValidNumber(to, "CA");
  }

  _smsFailure() {
    const smsFailure = !this._isValidNumber();
    this.setState({ smsFailure });
  }

  submitSMS(e) {
    e.preventDefault();
    if (!this._isValidNumber()) {
      this._smsFailure();
    } else if (!this.state.smsFailure && !this.sending) {
      this.sending = true;
      const to = this._formatSMS();
      Jigsaw.Bandwidth.sendMobileAppLink({ to }, response => {
        Fraction.Helpers.removeModal();
        if (response.isSuccess()) {
          toastUtils.notify(i18n.t("messages.sms-success"), {
            type: "success",
            imageUrl: "/img/checkmark-circle_icon.svg"
          });
        }
        // Comment in the line below if we add a failure condition that doesn't unmount the modal
        // this.sending = false
      });
    }
  }

  // submitEmail(e) {
  //   e.preventDefault();
  //   Jigsaw.Email.sendMobileAppLink({to: this.state.email || Fraction.User.email}, response => {
  //     Fraction.Helpers.removeModal();
  //     if (response.isSuccess()) {
  //       Fraction.Helpers.toast(i18n.t('messages.email-success'), {type: "mobile", img: {src: "/img/checkmark-circle_icon.svg"}});
  //     }
  //   });
  // }

  _formatSMS() {
    const { sms } = this.state;
    let to = "";
    // Converts letters to dial-pad number
    for (let i = 0; i < sms.length; i++) {
      const chr = sms[i];
      to += LETTER_CONVERSION[chr] || chr;
    }
    // Strips out any non-numeric characters
    return to.replace(/[^\d]/g, "");
  }

  render() {
    return (
      <div>
        <img src="/img/phones_3x.png" />
        <div id="mobile-apps-border" />
        <p>{i18n.t("mobile-apps.quick-link")}</p>
        <div>
          <form onSubmit={this.submitSMS}>
            <VstInput
              id="mobile-apps-sms"
              failure={
                this.state.smsFailure && i18n.t("mobile-apps.invalid-number")
              }
              label={i18n.t("mobile-apps.mobile-number")}
              value={this.state.sms}
              onChange={this.onChange("sms")}
              onFocus={this._onFocus("smsFailure")}
              onBlur={this._smsFailure}
              placeholder="(555) 555-5555"
            />
            <VstButton>
              <img className="sms-icon" src="/img/speech_bubble_icon.svg" />
              <span>{i18n.t("mobile-apps.send-sms")}</span>
            </VstButton>
          </form>
        </div>
      </div>
    );
  }
}

// <form onSubmit={this.submitEmail}>
//   <VstInput
//     id="mobile-apps-email"
//     label={i18n.t('base.email')}.replace(/[^\d]/g, '')
//     value={this.state.email}
//     onChange={this.onChange('email')}
//     placeholder={Fraction.User.email}
//     />
//   <VstButton>
//     <img className="email-icon" src="/img/email_icon.svg" />
//     <span>{i18n.t('mobile-apps.send-email')}</span>
//   </VstButton>
// </form>

const LETTER_CONVERSION = {
  A: "2",
  a: "2",
  B: "2",
  b: "2",
  C: "2",
  c: "2",
  D: "3",
  d: "3",
  E: "3",
  e: "3",
  F: "3",
  f: "3",
  G: "4",
  g: "4",
  H: "4",
  h: "4",
  I: "4",
  i: "4",
  J: "5",
  j: "5",
  K: "5",
  k: "5",
  L: "5",
  l: "5",
  M: "6",
  m: "6",
  N: "6",
  n: "6",
  O: "6",
  o: "6",
  P: "7",
  p: "7",
  Q: "7",
  q: "7",
  R: "7",
  r: "7",
  S: "7",
  s: "7",
  T: "8",
  t: "8",
  U: "8",
  u: "8",
  V: "8",
  v: "8",
  W: "9",
  w: "9",
  X: "9",
  x: "9",
  Y: "9",
  y: "9",
  Z: "9",
  z: "9"
};
